import React, { Component } from 'react';
import Header from './components/Header';
import Footer from './components/Footer';
import banner from './images/banner2.png';
import celebrity from './images/celebrity.png';
import down_arrow from './images/down_arrow.png';
import iphone2 from './images/iphone2.png';
import iphone3 from './images/iphone3.png';
import media from './images/media.png';
import paypal from './images/paypal.png';
import share from './images/share.png';
import submit from './images/submit_ok.png';
import venmo from './images/venmo.png';
import './css/Hangon.css'

class Hangon extends Component {
  render() {
    return (
      <div className="App">
        <Header />
        <div className="banner">
          <img src={banner} alt="Try something new" />
        </div>
        <div className="App-content">
          <div className="separator"></div>
          
          <div className="video">
          	WATCH THE VIDEO TO LEARN MORE
          	<iframe title="youtube" width="100%" height="100%" src="https://www.youtube.com/embed/_-_bSdWEYK8" frameBorder="0" allowFullScreen></iframe>
          </div>

          <div className="separator"></div>

          <div className="steps">
            {/* step 1 */}
          	<div className="step">
          		<p><span className="orange">1.</span> DO YOU ACCEPT?</p>
          		<p>USE PHONE BELOW TO CHOOSE OPTION</p>
          	</div>
          	
          	<div className="iphone">
	            <img src={iphone2} alt="iphone" />
            </div>

            <div className="input-div">
              <input name="your_email" placeholder="ENTER EMAIL" type="text" />
            </div>

            {/* step 2 */}
            <div className="step">
              <p><span className="orange">2.</span> CHOOSE A CELEBRITY TO CHALLENGE.</p>
              <p>SEE HOW MUCH THEY HAVE ON THE LINE..</p>
            </div>

            <div className="celebrity">
              <img src={celebrity} alt="celebrity" />
            </div>
            <div className="celebrity-value">$16.5K</div>

            {/* interactive search dropdown start */}
            <div className="input-group twitter-handle">
              <input name="tweet-name" placeholder="ENTER TWITTER HANDLE" type="text" />
              <span className="input-group-btn">
                <img src={down_arrow} alt="down arrow" />
              </span>
            </div>
            <div className="search-result">
              <div className="result-item">
                <div>@JustinBieber</div>
                <div>$16.5K</div>
              </div>
              <div className="clear"></div>
              <div className="result-item">
                <div>@TaylorSwift</div>
                <div>$15K</div>
              </div>
              <div className="clear"></div>
              <div className="result-item">
                <div>@JohnnyDepp</div>
                <div>$13.5K</div>
              </div>
              <div className="clear"></div>
              <div className="result-item">
                <div>@ArnoldSchwarzengger</div>
                <div>$12K</div>
              </div>
              <div className="clear"></div>
            </div>
            {/* interactive search dropdown end */}

            <div className="step">
              <p>CHALLENGE A FRIEND</p>
            </div>

            <div className="input-div2">
              <input name="facebook-name" placeholder="ENTER FACEBOOK NAME" type="text" />
              <div>SEPARATE BY (,) COMMAS</div>
            </div>

            {/* step 3 */}
            <div className="step">
              <p><span className="orange">3.</span> HOW MUCH ARE YOU PUTTING UP?</p>
              <p>SELECT USER THEN DOLLAR AMOUNT CHOOSE DOLLAR($) AMOUNT (BLANK WILL BE $0)</p>
            </div>
            <div className="select-dollar">
              <div>2</div>
              <div>5</div>
              <div>10</div>
            </div>
            <div className="input-div2">
              <input name="custom-amount" placeholder="ENTER CUSTOM AMOUNT ($)" type="text" />
            </div>
            <div className="apply-all">
              APPLY TO ALL
            </div>
            <div className="apply-option">
              <div className="option">
                <div>CHALLENGE 1</div>
                <div>$0</div>
              </div>
              <div className="option selected top-border">
                <div>@JUSTINBIEBER</div>
                <div>$10</div>
              </div>
              <div className="option top-border">
                <div>CHALLENGE 3</div>
                <div>$0</div>
              </div>
              <div className="option top-border">
                <div>CHALLENGE 4</div>
                <div>$0</div>
              </div>
            </div>

            {/* step 4 */}
            <div className="step">
              <p><span className="orange">4.</span> CHOOSE CHARITY TO BENEFIT.</p>
              <p>ONE CHARITY PER CHALLENGE</p>
            </div>
            <div className="input-div">
              <input name="charity-name" placeholder="ENTER NAME OF CHARITY" type="text" />
            </div>
            <div className="details">
              THIS CHALLENGE WAS CREATED TO SUPPORT THE ANXIETY AND DEPRESSION ASSOCIATION OF AMERICA
              <span className="blue">ADAA.ORG</span>. HALF OF THE NET PROFIT WILL GO TO SAID CHARITY
              AND THE OTHER HALF TO THE CHARITY YOU SPECIFY ABOVE.
            </div>

            {/* step 5 */}
            <div className="step">
              <p><span className="orange">5.</span> HOW WOULD YOU LIKE TO DONATE?</p>
              <p>CHOOSE OPTION BELOW.</p>
            </div>
            <div className="payment-option">
              <div className="first">
                <img src={venmo} alt="venmo" />
              </div>
              <div className="second">
                <img src={paypal} alt="paypal" />
              </div>
            </div>
            <div className="card-info">
              <div>
                <input name="card-name" placeholder="NAME ON CARD" type="text" />
              </div>
              <div>
                <input name="card-no" placeholder="CREDIT CARD #" type="text" />
              </div>
              <div>
                <input name="card-expire" placeholder="XX / XX" type="text" />
                <span>&nbsp;&nbsp;&nbsp;</span>
                <input name="card-csc" placeholder="CSC #" type="text" />
              </div>
            </div>
            <div className="payment-info">
              <div className="line">
                <div>YOU ARE PUTTING UP</div>
                <div>$14</div>
              </div>
              <div className="line">
                <div>TO CHALLENGE</div>
                <div>@JUSTINBIEBER</div>
              </div>
              <div className="line">
                <div>USING</div>
                <div>VENMO</div>
              </div>
              <div className="line">
                <div></div>
                <div style={{margin:"-17px -15px 0 0"}}>_______________________</div>
              </div>
            </div>

            {/* step 6 */}
            <div className="step">
              <p><span className="orange">6.</span> SUBMIT AND UPLOAD YOUR VIDEO!</p>
              <p>UPLOAD VIDEO LATER USING LINK IN EMAIL</p>
            </div>
            <div className="media-upload">
              <div>
                <img src={media} alt="media" />
              </div>
              <div>
                <img src={submit} alt="submit" />
              </div>
            </div>
            <div className="iphone3">
              <img src={iphone3} alt="iphone" />
            </div>
            <div className="share">
              <div>SHARE</div>
              <img src={share} alt="share" />
            </div>

          </div>

          <div className="separator"></div>

        </div>

        <Footer />

      </div>
    );
  }
}

export default Hangon;


// WEBPACK FOOTER //
// ./src/Hangon.js